import { render, staticRenderFns } from "./add-default-cc.vue?vue&type=template&id=4fc07bae&"
import script from "./add-default-cc.vue?vue&type=script&lang=ts&"
export * from "./add-default-cc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports